import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { PaymentMethodTypes, PaymentMethodUtils } from '@/models/payment_method/payment_method_types_enum';
import { PaymentMethod } from '@/models/payment_method/payment_method_model';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentMethodCard',
  props: {
    paymentMethods: { type: Array, required: true }
  },
  emits: ["change-method"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emits = __emit;

const selected = ref<PaymentMethod | null>(null);

function getMethods() {
  const methods: PaymentMethod[] = props.paymentMethods.map(e => {
    return new PaymentMethod({
      type: e.type,
      name: PaymentMethodUtils.getName(e.type),
      icon: PaymentMethodUtils.getIcon(e.type),
      msg: PaymentMethodUtils.getMessage(e.type),
    });
  });
  if (methods.length === 1) {
    selected.value = methods[0];  
    emits('change-method', methods[0].type);
  }
  return methods;
}


const __returned__ = { props, emits, selected, getMethods, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})